import React from 'react';

const ErrorComponent = () => {
  return <div>Error custom component not found!</div>;
};

export default ErrorComponent;
